export default __webpack_public_path__ + "static/media/box.f0b945f3.svg";